import React, { createContext, useContext } from "react";

const ContextProvider = createContext();

export const ShipmentContext = ({ children, value }) => {
  return (
    <ContextProvider.Provider value={value}>
      {children}
    </ContextProvider.Provider>
  );
};

export const useShipmentContext = () => {
  const context = useContext(ContextProvider);
  if (context === "undefined") {
    throw new Error("ShipmentContext was used outside of the provider");
  }
  return context;
};
